<template>
  <router-view />
</template>

<script setup>
// This component is now just a mounting point for the router.
// Layouts are handled at the route level.
</script>